import { NotificationService } from 'src/app/service/notification.service';
import { AssignmentPortalService } from 'src/app/service/assignment-portal.service';
import { LocalStorageService } from 'ngx-webstorage';
// import { MemberInformationService } from './../service/member-information.service';
// import { Member } from './../model/member-information/member-information';
import { FormBuilder, EmailValidator } from '@angular/forms';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms'
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { AssignmentQueue } from 'src/app/model/assignment-portal/assignment-portal';
import { AssignmentQueueRequest } from 'src/app/model/assignment-portal/assignment-queue-request';
import { Client } from 'src/app/model/assignment-portal/client';
import { Project } from 'src/app/model/assignment-portal/project';
import { ClientService } from 'src/app/service/client.service';
import { ProjectService } from 'src/app/service/project.service';

@Component({
  selector: 'app-manage-coder',
  templateUrl: './manage-coder.component.html',
  styleUrls: ['./manage-coder.component.scss']
})
export class ManageCoderComponent implements OnInit {

  assignmentQueue: AssignmentQueue = new AssignmentQueue();
  manageCoderForm: FormGroup;

  //qaNeeded: Number;
  clients: Client[];
  projects: Project[];
  selectedClient: string;
  selectedProject: string;
  //isSubmitButtonDisabled: Boolean = false;
  enableReset: boolean = false;

  assignmentQueueRequest: AssignmentQueueRequest = new AssignmentQueueRequest();
  //@ViewChild('multiSelect') multiSelect;

  manageCoderFormArray(): FormArray {
    return this.manageCoderForm.get('manageCoderFormArray') as FormArray
  }

  //localStoreMemberName: string = "";
  //localStoreMemberId: string = "";
  //localStoreProviderId: string = "";

  constructor(public _assignmentPortalService: AssignmentPortalService,
    private _notificationService: NotificationService,
    private clientService: ClientService,
    private projectService: ProjectService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _localStorage: LocalStorageService,
    public dialogRef: MatDialogRef<ManageCoderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AssignmentQueue
  ) {

  }

  ngOnInit() {
    this.manageCoderForm = this._formBuilder.group({
      //memberId: new FormControl({ value: this.data.memberId, disabled: true }),
      //memberName: new FormControl({ value: this.data.memberName, disabled: true }),
      coderLevel: new FormControl({ value: this.data.coderLevel, disabled: true }),
      qaNeeded: new FormControl({ value: this.data.qaNeeded, disabled: false }, [Validators.max(100), Validators.min(0)]),
      //clientNames: new FormControl({ value: this.data.clientNames, disabled: false }),
      //projectNames: new FormControl({ value: this.data.projectNames, disabled: false }),
      assignedClients: new FormControl({ value: this.data.assignedClients, disabled: false }),
      assignedProjects: new FormControl({ value: this.data.assignedProjects, disabled: false }),
    });
    this.initData();
  }

  initData() {
    //this.assignmentQueue = result.getDeafaultManageCoderListData;
    //this.clientList = this.data.assignedClient;
    //this.projectList = result.getDeafaultManageCoderListData.projectNames;
    this.onSelecetionChange(this.data.coderLevel);
    this.getClientList();
    this.projects = [];
    this.getProjectsByClients(this.data.assignedClients);
    //this.data.assignedClients.forEach(item => {
    //  this.getProjects(item + '');
    //});    
  }

  getClientList() {
    this.clientService.getClients().subscribe(result => {
      if (!result) {
        return;
      }
      this.clients = result.clients;
      this.manageCoderForm.get('assignedClients').patchValue(this.data.assignedClients)
      console.log("Client Name: " + this.clients[0].clientName);
    }, error => console.log(error));
  }

  getProjectsByClient({ value }) {
    //alert(value);
    this.projects = [];
    this.getProjectsByClients(value);
  }

  getProjectsByClients(value: number[]) {
    //alert(value);
    this.projectService.getProjectsByClientIds(value)
    .subscribe(result => {
      if (!result) {
        return;
      }
      console.log(result);
      this.projects = result.projects;
      //this.selectedProject = this.assignedNP.projectId+'';
      console.log("projects: " + this.projects);
    }, error => console.log(error));
  }

  
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    //console.log('key-'+charCode);
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    //console.log('qaNeeded-value: '+this.manageCoderForm.get("qaNeeded").value)
    if(this.manageCoderForm.get("qaNeeded").value == 0 ){
      return false;
    }else if(this.manageCoderForm.get("qaNeeded").value == 10 ){
      if((charCode != 48)){
        return false;
      }
    }else if (this.manageCoderForm.get("qaNeeded").value > 10){
      return false;
    }
    return true;

  }

  selectClient(event: Event) {
    this.selectedClient = (event.target as HTMLSelectElement).value;
  }
  selectProject(event: Event) {
    this.selectedProject = (event.target as HTMLSelectElement).value;
  }

  onNoClick(): void {
    this.dialogRef.close();
    //console.log(this.icd10CodeForm.value);
    this._notificationService.success(':: Closed successfully');
  }

  count: number = 0;
  onSubmit() {
    console.log('submitted....'+(++this.count));
    this.assignmentQueueRequest = this.manageCoderForm.value;
    this.assignmentQueueRequest.coderId = this.data.coderId;
    this.assignmentQueueRequest.id = this.data.id;
    this.assignmentQueueRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
    //alert(this.manageCoderForm.get("selectedClient").value);
    //this.assignmentQueueRequest.assignedClients = this.manageCoderForm.get("selectedClient").value.toString();
    //this.assignmentQueueRequest.assignedProjects = this.manageCoderForm.get("selectedProject").value.toString();
    this._assignmentPortalService.saveManageCoder(this.assignmentQueueRequest)
      .subscribe(data => {
        console.log(data)
        this.dialogRef.close(this.manageCoderForm.value);
        this._notificationService.success('Updated successfully');
      }, error => console.log(error));
  }

  onClose() {
    this.dialogRef.close();
    //console.log(this.icd10CodeForm.value);
    this._notificationService.success(':: Closed successfully');
  }

  onSelecetionChange(value: string) {
    if (value === 'level2') {
      this.manageCoderForm.get('qaNeeded').enable();
      this.manageCoderForm.get("qaNeeded").setValue(this.data.qaNeeded);
    }
    if (value === 'level1') {
      this.manageCoderForm.get("qaNeeded").setValue(100);
      this.manageCoderForm.get('qaNeeded').disable();
    }
  }

  panelSelected(panelOpen: boolean){
    if (!panelOpen) {
      this.enableReset = true;
    }
  }

  changeResetButton(){
    this.enableReset = false;
    //alert(this.data.portals+"<>"+this.data.roles)
    this.manageCoderForm.get('assignedClients').patchValue(this.data.assignedClients);
    this.manageCoderForm.get('assignedProjects').patchValue(this.data.assignedProjects);
   // this.getRoles(this.data.portals);
  }
}
